import React from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";

export default function Header() {
  return (
    <header className="relative w-full min-h-[70vh] bg-white flex flex-col justify-center items-center px-6 overflow-hidden pt-20">
      
      {/* Dynamic Background Elements (Optional soft gradient blobs, common in clean tech sites) */}
      <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-teal-500 opacity-[0.03] rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-teal-700 opacity-[0.03] rounded-full blur-[100px] pointer-events-none" />

      <motion.div 
        className="z-10 w-full max-w-5xl flex flex-col items-start lg:items-center text-left lg:text-center"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.span 
          className="text-teal-500 font-medium tracking-widest uppercase text-sm mb-4 inline-block"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          Portfolio 2024
        </motion.span>

        <h1 className="text-gray-900 font-extrabold text-[50px] md:text-[80px] lg:text-[100px] leading-[1.1] tracking-tight mb-6">
          Edwin Ramirez.
        </h1>

        <div className="text-gray-600 text-[24px] md:text-[36px] font-light mb-8 h-[40px] md:h-[60px] flex items-center lg:justify-center">
          <Typewriter
            options={{
              strings: [
                "Computer Systems Engineer.",
                "Full Stack Developer.",
                "Problem Solver.",
              ],
              autoStart: true,
              loop: true,
              delay: 50,
              deleteSpeed: 30,
            }}
          />
        </div>

        <motion.p 
          className="text-gray-500 text-lg text-[20px] md:text-xl max-w-2xl font-light leading-relaxed mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Building robust software solutions for 6+ years. I specialize in designing and engineering highly polished, scalable applications.
        </motion.p>

        <motion.div 
          className="flex gap-6 items-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          <a
            href="https://github.com/EdwinRM"
            target="_blank"
            rel="noreferrer"
            className="text-gray-900 hover:text-teal-500 transition-colors p-3 bg-gray-50 rounded-full hover:bg-gray-100"
          >
            <FaGithub size={24} />
          </a>
          <a
            href="https://www.linkedin.com/in/edwinrm/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-900 hover:text-teal-500 transition-colors p-3 bg-gray-50 rounded-full hover:bg-gray-100"
          >
            <FaLinkedin size={24} />
          </a>
          <a
            href="https://www.instagram.com/softwaredev39/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-900 hover:text-teal-500 transition-colors p-3 bg-gray-50 rounded-full hover:bg-gray-100"
          >
            <FaInstagram size={24} />
          </a>
        </motion.div>
      </motion.div>
      
      {/* Scroll indicator */}
      <motion.div 
        className="absolute bottom-10 left-1/2 -translate-x-1/2 w-[1px] h-16 bg-gray-200 overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
      >
        <motion.div 
          className="w-full h-1/2 bg-teal-500"
          animate={{ y: [0, 64] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
        />
      </motion.div>
    </header>
  );
}
